import React from 'react';

const IcCheckRoundFill = () => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <circle cx='12' cy='12' r='9' fill='#C2C4C8' />
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M15.9777 9.18826C16.2603 9.45205 16.2756 9.895 16.0118 10.1776L11.3451 15.1776C11.2127 15.3195 11.0274 15.4 10.8334 15.4C10.6394 15.4 10.454 15.3195 10.3216 15.1776L7.98831 12.6776C7.72453 12.395 7.7398 11.952 8.02243 11.6883C8.30505 11.4245 8.74801 11.4398 9.01179 11.7224L10.8334 13.6741L14.9883 9.22238C15.2521 8.93975 15.695 8.92448 15.9777 9.18826Z'
                fill='white'
            />
        </svg>
    );
};

export default IcCheckRoundFill;
